var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-field',{staticClass:"van-iput",attrs:{"name":_vm.valName,"placeholder":"请填写变量内容","clearable":"","rules":_vm.rules,"error-message":_vm.errorMessage},model:{value:(_vm.modelVal),callback:function ($$v) {_vm.modelVal=$$v},expression:"modelVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }